import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Heart, Stethoscope, Smile, Eye, Shield } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'SEGURO DE VIDA',
    subtitle: 'Porque tu familia merece estar protegida incluso cuando tú no estés',
    icon: Heart,
    points: ['Protección financiera para tu familia', 'Planes desde precios muy accesibles', 'Cobertura para gastos finales, deudas, hipoteca', 'Tu familia no quedará sola ni con deudas']
  }, {
    title: 'SEGURO DE SALUD',
    subtitle: 'Porque una visita al hospital sin seguro puede costarte $50,000 o más',
    icon: Stethoscope,
    points: ['Planes individuales y familiares', 'Subsidios disponibles según tu ingreso', 'Cubre emergencias, medicamentos, especialistas', 'Atención médica real sin arruinarte']
  }, {
    title: 'SEGURO DENTAL',
    subtitle: 'Porque tu sonrisa también merece protección',
    icon: Smile,
    points: ['Limpiezas, extracciones, coronas y más', 'Planes para toda la familia', 'Redes de dentistas en tu área', 'Cuida tu salud bucal sin gastar una fortuna']
  }, {
    title: 'SEGURO DE VISIÓN',
    subtitle: 'Porque ver bien es vivir bien',
    icon: Eye,
    points: ['Exámenes de la vista anuales', 'Lentes y armazones cubiertos', 'Detección temprana de glaucoma, cataratas', 'Tu visión protegida a un precio justo']
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-10 md:py-24 bg-white relative" data-id="element-331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-332">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-333">
          <div className="flex justify-center mb-4" data-id="element-334">
            <Shield className="w-12 h-12 text-gold" data-id="element-335" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-336">
            LO QUE PUEDO HACER POR TI Y TU FAMILIA
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-337">
            Trabajo con los mejores planes disponibles en el mercado para
            ofrecerte cobertura completa en cuatro áreas fundamentales:
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 gap-8" data-id="element-338">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-cream rounded-2xl p-8 border border-gold/20 hover:border-gold/50 transition-colors shadow-sm hover:shadow-md group" data-id="element-339">
                <div className="flex items-center gap-4 mb-6" data-id="element-340">
                  <div className="bg-navy p-3 rounded-xl group-hover:bg-gold transition-colors" data-id="element-341">
                    <Icon className="w-8 h-8 text-white" data-id="element-342" />
                  </div>
                  <div data-id="element-343">
                    <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-344">
                      {service.title}
                    </h3>
                  </div>
                </div>

                <p className="text-gold-dark font-medium italic mb-6 text-lg border-b border-gold/20 pb-4" data-id="element-345">
                  {service.subtitle}
                </p>

                <ul className="space-y-3" data-id="element-346">
                  {service.points.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-347">
                      <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-navy shrink-0" data-id="element-348" />
                      <span className="text-gray-700" data-id="element-349">{point}</span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}